<template>
		<div class="content home-page">
      <Header></Header>
			<div class="setting-content crfff ac por">
        <span class="fs50 w-title ac">{{$t('Settings')}}</span>
        <div class="btn-purple mt50">
          <span>
            <div class="disflex" style="justify-content: center;">
              <div class="fs50" style="width: 60%;">{{$t('BackgroundMusic')}}</div>
              <div class="kai" @click="getShow(1)" v-if="isShow"><img src="../../static/images/kai.png"></div>
              <div class="kai kai2" @click="getShow(2)" v-else><img src="../../static/images/kai2.png"></div>
            </div>
          </span>
        </div>
        <div class="btn-purple mt30">
          <span>
            <div class="fs36 mt30">{{$t('languageTips')}} :</div>
            <div class="change-list mt30 disflex change-list2 ac">
              <div class="one" @click="getLang(2,'en')" :class="{'active':isLang=='en'}">
                <img class="dui" v-if="isLang=='en'" src="../../static/images/dui.png">
                <img class="dui" v-else src="../../static/images/dui2.png">
                <div class="mt20">{{$t('English')}}</div>
              </div>
              <div class="one" @click="getLang(2,'bur')" :class="{'active':isLang=='bur'}">
                <img class="dui" v-if="isLang=='bur'" src="../../static/images/dui.png">
                <img class="dui" v-else src="../../static/images/dui2.png">
                <div class="mt20">{{$t('Myanmar')}}</div>
              </div>
            </div>
          </span>
        </div>
        <div class="ac otp-b crfff mt30">
          <div class="btn-purple" style="font-size: 38px;width: 80%;margin: 0 auto;" @click="getType('termsAndCondition')"><span style="padding:30px 20px" class="app-en">{{$t('TC')}}</span></div>
          <div class="btn-purple mt30" style="font-size: 38px;width: 80%;margin: 0 auto;" @click="getType('faq')"><span style="padding:30px 20px" class="app-en">{{$t('FAQ')}}</span> </div>
        </div>
        <div class="home-bottom disflex">
          <div class="bt-icon1" @click="getToNav('book')">
            <img src="../../static/images/mb-ic1.png">
            <span class="">{{$t('books')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('bank')">
            <img src="../../static/images/mb-ic2.png">
            <span class="">{{$t('bank')}}</span>
          </div>
          <div class="bt-icon1 bt-icon2" @click="getToNav('')">
            <img src="../../static/images/mb-ic3.png">
            <span class="">{{$t('home')}}</span>
          </div>
          <div class="bt-icon1" @click="getToNav('shop')">
            <img src="../../static/images/mb-ic4.png">
            <span class="">{{$t('shop')}}</span>
          </div>
          <div class="bt-icon1 active" @click="getToNav('language')">
            <img style="margin-top: -30px;"  src="../../static/images/mb-ic5-h.png">
            <span class="">{{$t('Settings')}}</span>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import AudioService from '@/services/AudioService'
export default {
    components:{
      Header
    },
    data() {
      return {
        list:[],
        lang:'',
        isLang:'bur',
        isShow:this.$parent.isBgmPlaying || false,
      }
    },
	created(){
    if(localStorage.getItem('lang')){
      this.isLang = localStorage.getItem('lang')
    }
    this.isShow = JSON.parse(localStorage.getItem('BackgroundMusic'))
	},
    methods: {

      getToNav(url){
        this.$router.push({path:'/'+url});
      },
      back(){
        this.$router.go(-1);
      },

      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      getShow(type){
        if (type === 1) {
          this.isShow = false;
          this.$parent.stopBackgroundMusic(); // 使用 $parent 访问
        } else {
          this.isShow = true;
          this.$parent.startBackgroundMusic(); // 使用 $parent 访问
        }
      },

      getLang(type,lang){
        this.isLang = lang
        this.lang = lang
        localStorage.setItem('lang',this.lang)
        // this.$router.push({path:'/',query:{}});
        location.reload()
      },
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/language.vue